<template>
  <div class="proyectos-view">
    <header class="coming-soon-hero">
      <img src="/img/proyectos/obra-en-construccion.jpg" alt="Obra en construcción Tasoar" class="hero-bg-image">
      <div class="hero-overlay"></div>

      <div class="hero-content">
        <span class="hero-icon"><i class="fa-solid fa-person-digging"></i></span>
        <h1>Estamos trabajando en <span>grandes proyectos</span></h1>
        <p class="hero-subtitle">
          Muy pronto podrás ver aquí todo nuestro portafolio de proyectos realizados.
        </p>
        <router-link to="/contacto" class="cta-button">
          Cotiza tu proyecto <i class="fa-solid fa-arrow-right"></i>
        </router-link>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'ProyectosView'
};
</script>

<style scoped>
.proyectos-view {
  color: #2c3e50;
}

.coming-soon-hero {
  position: relative;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: var(--color-primary);
}

.hero-bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 30, 77, 0.88);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 640px;
  padding: 40px 25px;
  color: #ffffff;
}

.hero-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  font-size: 2.2rem;
  color: #ffffff;
  margin-bottom: 25px;
}

.hero-content h1 {
  font-size: 2.3rem;
  font-weight: 800;
  line-height: 1.3;
  margin: 0 0 15px 0;
  text-shadow: 2px 2px 6px rgba(0,0,0,0.4);
}

.hero-content h1 span {
  color: var(--color-text);
}

.hero-subtitle {
  font-size: 1.1rem;
  color: #cfe0f5;
  line-height: 1.6;
  margin: 0 0 30px 0;
}

.cta-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background-color: var(--color-text);
  color: #ffffff;
  text-decoration: none;
  font-weight: 700;
  padding: 14px 30px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

.cta-button:hover {
  background-color: #075bc4;
}

@media (max-width: 768px) {
  .coming-soon-hero {
    min-height: 420px;
  }

  .hero-content h1 {
    font-size: 1.7rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .hero-icon {
    width: 64px;
    height: 64px;
    font-size: 1.7rem;
  }

  .hero-content h1 {
    font-size: 1.4rem;
  }

  .cta-button {
    width: 100%;
    justify-content: center;
  }
}
</style>